const SENTENCE = {
    categories: ['What are', 'viewing alongside'],
    brands: ['Which brands are', 'viewing alongside'],
    flavors: ['What flavors are', 'viewing alongside'],
    flavorsSearched: ['What flavors are', 'searching in'],
};

const alongsideSubtitle = (subject, name) => {
    const [lead, verb] = SENTENCE[subject];
    return (
        <>
            {lead} consumers {verb} <span className="capitalize">{name}</span>?
        </>
    );
};

export default alongsideSubtitle;
